// react
import React from 'react'

// components
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import Header from '_components/header/index.jsx'
import NewEntityDialog from '_components/new-entity-dialog/index.jsx'
import ListView from '_components/list-view/index.jsx'

class UserAttributeSyncs extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modalOpen: false,
    }
  }

  toggleModal = () => {
    this.setState((prevState) => ({
      modalOpen: !prevState.modalOpen,
    }))
  }

  render() {
    return (
      <div id="user-attribute-syncs-page">
        <Header
          title="User Attribute Syncs"
          actions={[
            {
              children: 'Create User Attribute Sync',
              onClick: this.toggleModal,
            },
          ]}
        />

        <ListView
          columns={[
            {
              name: 'Name',
              key: 'name',
              link: '/user-attribute-syncs/:_id',
              sortable: true,
              width: 300,
            },
            {
              key: 'destination',
              name: 'Destination',
            },
            {
              key: 'attributes',
              name: 'Attributes',
            },
            {
              format: 'date',
              key: 'created_at',
              name: 'Created on',
              sortable: true,
            },
          ]}
          entities="user-attribute-syncs"
          filters={[]}
          fields={['name', 'attributes', 'created_at', 'destination']}
          searchable={true}
          sort_key={'created_at'}
          sort_dir={-1}
        />
        <Dialog open={this.state.modalOpen} close={this.toggleModal}>
          <NewEntityDialog
            close={this.toggleModal}
            entities="user-attribute-syncs"
            title="Enter a name for your new User Attribute Sync"
          />
        </Dialog>
      </div>
    )
  }
}

// export
export default UserAttributeSyncs
